import type { ReactNode } from "react";

import { EnvironmentTag } from "@/ui/environment-tag";
import { Logo } from "@/ui/logo";

import { AccountMenu } from "./AccountMenu";

/** Pages before a brand is chosen (choosing one, invitations): logo, account and one narrow column. */
export function SimpleLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col bg-bg">
      <header className="flex items-center justify-between gap-3 border-b border-border bg-surface px-4 py-3 sm:px-8">
        <div className="flex items-center gap-3">
          <Logo subtitle="Partner" />
          <EnvironmentTag />
        </div>
        <AccountMenu compact />
      </header>
      <main id="main" tabIndex={-1} className="mx-auto flex w-full max-w-2xl flex-col gap-6 px-4 pt-8 pb-12">
        {children}
      </main>
    </div>
  );
}
